import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditItemView from "../common/components/EditItemView";

/* -------------------- COMPONENT -------------------- */

const PresenceReportPage = () => {
  const [item, setItem] = useState(null);

  /* -------------------- VALIDATION -------------------- */

  const validate = () => {
    return item && item.note;
  };

  /* -------------------- UI -------------------- */

  return (
    <EditItemView
      endpoint="presence"
      item={item}
      setItem={setItem}
      validate={validate}
    >
      {item && (
        <Accordion defaultExpanded>

          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>📅 Presence Report</Typography>
          </AccordionSummary>

          <AccordionDetails
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 16
            }}
          >

            {/* NOTE ONLY */}
            <TextField
              label="Note"
              multiline
              minRows={4}
              value={item.note || ""}
              onChange={(e) =>
                setItem({ ...item, note: e.target.value })
              }
              fullWidth
            />

          </AccordionDetails>

        </Accordion>
      )}
    </EditItemView>
  );
};

export default PresenceReportPage;